const styles = {
  breakpoints: {
    content: [1, 1, 1, 0.85, 0.85],
  },
};

export default styles;
